import styled from "styled-components";

interface IItem {
  color?: string
}

interface IItemWrapp {
  mobileOrder: number|string
}

export const ItemsContainer = styled.div`
  margin: 36px 0 0 0;
  width: 100%;
  
  @media (min-width: 1200px) {
    width: 1024px;
  }
  
  @media (min-width: 980px) {
    margin: 60px auto 0;
  }
`

export const ItemsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -12px;
  
  @media (min-width: 980px) {
    margin-bottom: -35px;
  }
`

export const ItemWrapp = styled.div<IItemWrapp>`
  flex: 0 0 100%;
  padding: 12px;
  order: ${({ mobileOrder }) => mobileOrder};
  
  @media (min-width: 375px) {
    padding: 12px;
    flex: 0 0 50%;
  }
  
  @media (min-width: 980px) {
    flex: 0 0 25%;
    padding: 35px 0;
    font-size: 16px;
    order: initial;
  }
`

export const Item = styled.div<IItem>`
  padding: 20px;
  position: relative;
  font-size: 14px;
  line-height: 160%;
  color: #4E4963;
  min-height: 160px;
  font-weight: 600;

  @media (min-width: 375px) {
    padding: 20px 0 0 20px;
  }
  
  &::before {
    content: '';
    position: absolute;
    display: block;
    border-radius: 25px;
    opacity: .3;
    background: ${({ color }) => color && color || '#fff'};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  
  @media (min-width: 980px) {
    padding: 21px;
    font-size: 16px;
    
    &::before {
      width: 140px;
      height: 140px;
    }
  }
`

export const ItemInner = styled.div`
  position: relative;
  
  @media (min-width: 980px) {
    display: flex;
    align-items: flex-start;
  }
`

export const CheckIcon = styled.span`
  width: 20px;
  height: 20px;
  vertical-align: top;
  margin-bottom: 12px;
  display: block;
  
  @media (min-width: 980px) {
    margin-right: 12px;
    margin-bottom: 0;
    display: inline;
  }
  
  svg path {
    stroke: #2A2637;
  }
`